/*
 * @Author: Teemo Ding
 * @Date: 2021-11-30 11:25:56
 * @LastEditTime: 2021-12-03 11:08:26
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/Components/Additional/config.tsx
 */
import React from 'react';
import { isNumber } from 'src/tools/helper';
import { EnumFilterType } from 'src/constrains/Query1/Filter';
import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import {
  EnumLinkProductType1,
  //typeDict,
} from 'src/types/common/salesChannelProduct';
import { EnumTablePosition } from 'src/types/common/common';
import css from './css.module.less';

export const customColumns = ({ getI18n }) => [
  {
    title: getI18n('general.productName'),
    dataIndex: 'productName',
    default: true,
    sorter: (a, b) => {
      const name1 = a.productName || '';
      const name2 = b.productName || '';
      const n1 = name1.toLowerCase();
      const n2 = name2.toLowerCase();
      if (n1 > n2) return 1;
      if (n2 > n1) return -1;
      return 0;
    },

    className: css.expandRow,
    key: 'productName',
    childGenerate: (text, record) => {
      const { thumbnailUrl, productName } = record;
      const name = productName || '-';
      return (
        <div className={css.productNameContain}>
          {thumbnailUrl && (
            <img
              style={{
                marginRight: 12,
              }}
              width={40}
              height={40}
              key={thumbnailUrl}
              src={thumbnailUrl}
              alt={thumbnailUrl}
            />
          )}
          <NoWrapContainer>
            <GlobalTooltip title={name}>
              <div className={css.text}>{name}</div>
            </GlobalTooltip>
          </NoWrapContainer>
        </div>
      );
    },

    width: 258,
  },
  {
    title: getI18n('general.sKU'),
    dataIndex: 'sku',
    default: true,

    key: 'sku',

    width: 120,
  },
  {
    title: getI18n('allOrders.orderDetail.productItems_config_type_title'), //'Type',
    dataIndex: 'productType',
    default: true,
    key: 'productType',
    width: 150,
  },
  {
    title: getI18n('allOrders.orderDetail.productItems_config_Available_title'),
    dataIndex: 'available',
    default: true,
    align: 'right',
    key: 'available',
    position: EnumTablePosition.right,
    width: 107,
  },
  {
    titleGenerate: () => (
      <div>
        {getI18n('allOrders.orderDetail.productItems_config_listPrice_title')}
      </div>
    ),
    default: true,
    dataIndex: 'listPrice',
    key: 'listPrice',
    width: 145,
    childGenerate: (text) => {
      const data = isNumber(text) ? text.toFixed(2) : '';
      return (
        <NoWrapContainer>
          <GlobalTooltip title={data}> {data || ''}</GlobalTooltip>
        </NoWrapContainer>
      );
    },
  },
];

export const filterList = ({ tags, getI18n }) => [
  {
    type: EnumFilterType.SingleSelection,
    dropdownProps: { name: getI18n('general.type') },
    keyWord: 'productTypes',
    options: [
      {
        label: getI18n('general.status.singlePhy'),
        value: EnumLinkProductType1.SinglePhysical,
      },
      {
        label: getI18n('general.status.singleSer'),
        value: EnumLinkProductType1.SingleService,
      },
      {
        label: getI18n('general.status.singleGC'),
        value: EnumLinkProductType1.SingleGiftCard,
      },
      {
        label: getI18n('general.status.multiplePhy'),
        value: EnumLinkProductType1.MultiplePhysical,
      },
      {
        label: getI18n('general.status.multipleVir'),
        value: EnumLinkProductType1.MultipleVirtual,
      },
    ],
  },
  {
    type: EnumFilterType.MultipleSelection,
    dropdownProps: { name: getI18n('general.tags') },
    keyWord: 'tags',
    options: tags.map((item) => ({
      label: item.name,
      value: item.uuid,
    })),
    searchable: true,
  },
  {
    type: EnumFilterType.SingleSelection,
    options: [
      {
        label: getI18n('general.visible'),
        value: 'visible-1',
      },
      {
        label: getI18n('general.invisible'),
        value: 'visible-0',
      },
    ],
    dropdownProps: { name: getI18n('general.visibility') },
    keyWord: 'visible',
  },
];

export const customerConvertQuery = (filter) => {
  const re: any = {};
  if (filter.productTypes) {
    if (filter.productTypes.length > 0) {
      re.productTypes = [filter.productTypes[0].value];
    }
  }
  if (filter.tags) {
    if (filter.tags.length > 0) {
      re.tags = filter.tags.map((i) => {
        const { value } = i;
        return { uuid: value };
      });
    }
  }

  if (filter.visible) {
    if (filter.visible.length > 0) {
      re.visible = filter.visible[0].value == 'visible-1' ? true : false;
    }
  }

  //if (customFilterTransfer) customFilterTransfer(filter, re);
  return re;
};
